/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const formInstanceValues = sqliteTable('form_instance_values', {
  id: text('id').primaryKey().notNull(),
  form_instance_id: text('form_instance_id'),
  field_key: text('field_key'),
  value: text('value'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
